import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove
    , setListArea, setAreaModelo, setGruposPuntuacionFila
    , setValidations
} from '../redux/sessionCriterionSlice'
import AutocompleteRegistro from './AutocompleteRegistro'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';

// El detalle de criterios de la sesion encadena los cuatro niveles del modelo:
// Modelo -> Area -> Objetivo -> Criterio. Los tres ultimos son autocompletados
// (AutocompleteRegistro) que filtran en local, buscan en el servidor al llegar
// a tres letras y ofrecen registrar el texto escrito cuando no existe.
const SessionCriterion = (props) => {
    const isReadOnly = props.isReadOnly;
    // Escala de avance del plan de la sesion: de ella salen los grupos de
    // puntuacion. Las filas ya guardadas no la traen, asi que se les aplica.
    //
    // La escala sale siempre del plan de terapia (idPuntuacionAvance): antes
    // habia un desplegable para elegirla a mano cuando la sesion no tenia
    // plan, y no debia haberlo (el dato es del plan).
    const idPuntuacionPlan = props.idPuntuacionPlan || 0;
    const escala = idPuntuacionPlan;
    // El modelo y la escala se eligen en el detalle cuando la sesion no tiene
    // plan; con plan vienen del detalle del plan y se muestran en solo lectura.
    const [modelos, setModelos] = useState([]);
    const params = useParams();
    const entity = useSelector((state) => state.sessionCriterion.entity)
    const defaultEntity = useSelector((state) => state.sessionCriterion.defaultEntity)
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);

    const validate = useSelector((state) => state.sessionCriterion.validationActive);
    const dispatch = useDispatch();

    var validation = {
        AtLeastOneRow: {
            // Lo obligatorio del criterio es el area... o el detalle: un
            // criterio sin area es un detalle libre (lo usa el modelo generico
            // y lo que alimenta el reporte trimestral).
            error: entity.length == 1
                &&
                (
                    (entity[0].idArea == null || entity[0].idArea == 0)
                    && (entity[0].area || "").trim().length == 0
                    && (entity[0].detalle || "").trim().length == 0
                ),
            message: "Debe haber por lo menos un area o un detalle",
        },
    }

    // Los indicadores del plan deciden si la fila pide objetivo y/o criterio.
    // Son los del plan de terapia de la sesion (llegan por props): si el plan no
    // pide ese nivel, el campo no se muestra. Sin plan (null) cada fila usa el
    // valor que heredo al crearse.
    const pideObjetivo = (row) => (props.detObjetivoPlan === null || props.detObjetivoPlan === undefined        ? row.detObjetivo !== false : props.detObjetivoPlan === true);
    const pideCriterio = (row) => (props.detCriterioPlan === null || props.detCriterioPlan === undefined
        ? row.detCriterio !== false : props.detCriterioPlan === true);

    // Un modelo sin areas es el "modelo generico": sus criterios solo llevan el
    // detalle (que es lo que alimenta el reporte trimestral), asi que el area,
    // el objetivo, el criterio y la escala no se muestran.
    const sinArea = (row) => row.idModelo > 0
        && Array.isArray(row.areaModelo)
        && row.areaModelo.length === 0;

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    // ---- Listas de los hijos segun el padre elegido ------------------------

    // Areas del modelo: alimentan el autocompletado de Area.
    const cargarAreasDelModelo = useCallback(async (idModelo, numero) => {
        // idModelo puede llegar como objeto (p.ej. si el select paso el modelo
        // completo): nos quedamos con su id.
        const id = (idModelo && typeof idModelo === 'object') ? (idModelo.id ?? idModelo.value ?? 0) : idModelo;
        if (!id || id <= 0) {
            dispatch(setAreaModelo({ numero: numero, areas: [] }));
            return;
        }
        const response = await api.get("/Modelo/GetsArea?idModelo=" + id)
            .catch((err) => { console.log("Err: ", err); });
        dispatch(setAreaModelo({ numero: numero, areas: response?.data?.data || [] }))
    }, [])

    // Objetivos del area: alimentan el autocompletado de Objetivo.
    const cargarObjetivosDelArea = useCallback(async (idArea, numero) => {
        if (!idArea || idArea <= 0) {
            setItemValue(numero, "areaObjetivo", [])
            return;
        }
        const response = await api.get("/Modelo/GetsAreaObjetivo?idArea=" + idArea)
            .catch((err) => { console.log("Err: ", err); });
        setItemValue(numero, "areaObjetivo", response?.data?.data || [])
    }, [])

    // Criterios del objetivo: alimentan el autocompletado de Criterio.
    const cargarCriteriosDelObjetivo = useCallback(async (idAreaObjetivo, numero) => {
        if (!idAreaObjetivo || idAreaObjetivo <= 0) {
            setItemValue(numero, "areaObjetivoCriterio", [])
            return;
        }
        const response = await api.get("/Modelo/GetsCriterio?idAreaObjetivo=" + idAreaObjetivo)
            .catch((err) => { console.log("Err: ", err); });
        setItemValue(numero, "areaObjetivoCriterio", response?.data?.data || [])
    }, [])

    // La vista de los criterios de la sesion no trae las listas de los hijos:
    // se piden para que los tres autocompletados tengan con que filtrar.
    const cargarListas = useCallback(async (rows) => {
        for (const row of (rows || [])) {
            if (row.idModelo > 0) await cargarAreasDelModelo(row.idModelo, row.numero);
            if (row.idArea > 0) await cargarObjetivosDelArea(row.idArea, row.numero);
            if (row.idAreaObjetivo > 0) await cargarCriteriosDelObjetivo(row.idAreaObjetivo, row.numero);
        }
    }, [cargarAreasDelModelo, cargarObjetivosDelArea, cargarCriteriosDelObjetivo])

    // ---- Busqueda en el servidor (al llegar a tres letras) ----------------

    const buscarArea = useCallback(async (idModelo, texto) => {
        if (!idModelo || idModelo <= 0) return [];
        const response = await api.get("/Modelo/BuscarArea?idModelo=" + idModelo
            + "&texto=" + encodeURIComponent(texto))
            .catch((err) => { console.log("Err: ", err); return { data: { data: [] } }; });
        return response?.data?.data || [];
    }, [])

    const buscarObjetivo = useCallback(async (idArea, texto) => {
        if (!idArea || idArea <= 0) return [];
        const response = await api.get("/Modelo/BuscarAreaObjetivo?idArea=" + idArea
            + "&texto=" + encodeURIComponent(texto))
            .catch((err) => { console.log("Err: ", err); return { data: { data: [] } }; });
        return response?.data?.data || [];
    }, [])

    const buscarCriterio = useCallback(async (idAreaObjetivo, texto) => {
        if (!idAreaObjetivo || idAreaObjetivo <= 0) return [];
        const response = await api.get("/Modelo/BuscarCriterio?idAreaObjetivo=" + idAreaObjetivo
            + "&texto=" + encodeURIComponent(texto))
            .catch((err) => { console.log("Err: ", err); return { data: { data: [] } }; });
        return response?.data?.data || [];
    }, [])

    // ---- Registrar un hijo nuevo -----------------------------------------

    const registrarArea = useCallback(async (idModelo, texto, numero) => {
        if (!idModelo || idModelo <= 0) return null;
        const response = await api.post("/Modelo/AddUpdateArea", {
            idModelo: idModelo, codigo: "", nombre: texto, descripcion: "", orden: 0
        })
        const id = response?.data?.data || 0;
        // Se recarga la lista del modelo para que el nuevo area quede disponible.
        if (id > 0) await cargarAreasDelModelo(idModelo, numero);
        return { id: id, nombre: texto };
    }, [cargarAreasDelModelo])

    const registrarObjetivo = useCallback(async (idArea, texto, numero) => {
        if (!idArea || idArea <= 0) return null;
        const response = await api.post("/Modelo/AddUpdateAreaObjetivo", {
            idArea: idArea, idDestreza: 0, codigo: "", nombre: texto,
            descripcion: "", orden: 0, pregunta: "", ejemplo: ""
        })
        const id = response?.data?.data || 0;
        // Se recarga la lista del area para que el nuevo objetivo quede disponible.
        if (id > 0) await cargarObjetivosDelArea(idArea, numero);
        return { id: id, nombre: texto };
    }, [cargarObjetivosDelArea])

    const registrarCriterio = useCallback(async (idAreaObjetivo, texto, numero) => {
        if (!idAreaObjetivo || idAreaObjetivo <= 0) return null;
        const response = await api.post("/Modelo/AddUpdateAreaObjetivoCriterio", {
            idAreaObjetivo: idAreaObjetivo, valor: 0, descripcion: texto, orden: 0
        })
        const id = response?.data?.data || 0;
        // Se recarga la lista del objetivo para que el nuevo criterio quede disponible.
        if (id > 0) await cargarCriteriosDelObjetivo(idAreaObjetivo, numero);
        return { id: id, descripcion: texto };
    }, [cargarCriteriosDelObjetivo])

    // ---- Carga inicial ----------------------------------------------------

    // Carga las areas del plan de terapia de la sesion: los planes de la
    // terapia cuyas fechas coinciden con las del periodo de la sesion.
    const fetchListArea = useCallback(async () => {
        const res = await api.get("/Terapia/GetTerapiaPeriodoResumenView?idTerapiaPeriodo=" + params.idTerapiaPeriodo)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: {} };
            });

        const terapiaPeriodo = res.data?.data;

        if (terapiaPeriodo == null) {
            dispatch(setListArea([]));
            return;
        }

        const resareas = await api.get("/TerapiaPlan/GetsAreaPorPeriodoAcademico"
            + "?idPeriodo=" + terapiaPeriodo.idPeriodo
            + "&idTerapia=" + terapiaPeriodo.idTerapia)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: {} };
            });

        dispatch(setListArea(resareas.data?.data || []));
    }, [])

    const fecthEntity = useCallback(async () => {
        // Un registro nuevo (id 0) no tiene nada que traer: el detalle de
        // criterios arranca VACIO, sin la fila por defecto, y el terapeuta
        // agrega sus filas con el boton de agregar o desde el plan.
        if (!params.id || params.id == 0) {
            dispatch(setEntity([]));
            fetchListArea();
            return;
        }

        const response = await api.get("/Sesion/GetsSesionCriterioView?idSesion=" + params.id)
            .then((response) => {
                // Una sesion existente sin criterios si muestra la fila en
                // blanco: es por donde se agrega el primero.
                const rows = (response.data.data == null || response.data.data.length == 0)
                    ? defaultEntity
                    : response.data.data;

                dispatch(setEntity(rows));

                fetchListArea();
                cargarListas(rows);
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }, [])
    // Los grupos de puntuacion de cada fila salen de la escala de avance del
    // plan del area: son los unicos validos para esa fila.
    const cargarGruposPuntuacion = useCallback(async (idPuntuacion, numero) => {
        if (!idPuntuacion || idPuntuacion <= 0) {
            dispatch(setGruposPuntuacionFila({ numero: numero, grupos: [] }));
            return;
        }

        const response = await api.get("/Puntuacion/GetsPuntuacionGrupoPorPuntuacion?idPuntuacion=" + idPuntuacion)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: { data: [] } };
            });

        dispatch(setGruposPuntuacionFila({ numero: numero, grupos: response?.data?.data || [] }));
    }, [])


    useEffect(() => {
        fecthEntity();
    }, [])

    // Los modelos se traen una vez: el detalle los necesita para que el
    // terapeuta elija por donde entra el criterio. Las escalas ya no se
    // eligen aqui: la escala de avance sale del plan de terapia.
    useEffect(() => {
        api.get("/Modelo/GetsModelo")
            .then((response) => setModelos(response.data?.data || []))
            .catch((err) => { console.log("Err: ", err); });
    }, [])

    // Cada fila pide los grupos de su escala de avance. Cuando la fila no
    // tiene escala (porque ya estaba guardada o porque no hay plan) usa la del
    // detalle.
    useEffect(() => {
        for (const row of (entity || [])) {
            cargarGruposPuntuacion(row.idPuntuacion > 0 ? row.idPuntuacion : escala, row.numero);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entity.map((row) => row.numero + ":" + row.idPuntuacion).join(","), idPuntuacionPlan, escala]);

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        await api.delete("/Sesion/DeleteSesionCriterio?idSesion="
                + params.id + "&numero=" + selectNumero)
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(remove(selectNumero));
   }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Criterios (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Criterio" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell sx={{ px: 0.5, py: 1 }}>
                                    {/* Una sola fila, alineada al centro: el modelo solo
                                        muestra su codigo, la puntuacion tiene mas ancho y
                                        el detalle queda a la misma altura que el boton
                                        de eliminar. */}
                                    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1, width: "100%", maxWidth: { lg: 980 } }}>
                                        {/* El modelo viene del detalle del plan de terapia
                                            (la flecha hacia abajo) y es de solo lectura.
                                            Sin plan no hay de donde sacarlo, asi que la
                                            fila lo elige: su codigo es el filtro padre de
                                            las areas. */}
                                        <Box sx={{ flex: "0 1 88px", minWidth: 76 }}>
                                            {row.idModelo > 0 ? (
                                                <TextField
                                                    disabled
                                                    name="codigoModelo"
                                                    label="Modelo"
                                                    fullWidth
                                                    size="small"
                                                    value={row.codigoModelo || ""}
                                                />
                                            ) : (
                                                <FormControl fullWidth size="small">
                                                    <InputLabel htmlFor="select-modelo">Modelo</InputLabel>
                                                    <Select
                                                        native
                                                        label="Modelo"
                                                        value={row.idModelo}
                                                        fullWidth
                                                        disabled={isReadOnly}
                                                        inputProps={{ name: 'idModelo', id: 'select-modelo' }}
                                                        onChange={(event) => {
                                                            const id = parseInt(event.target.value) || 0;
                                                            const modelo = modelos.find((m) => m.id === id);

                                                            setItemValue(row.numero, "idModelo", id);
                                                            setItemValue(row.numero, "codigoModelo", modelo ? (modelo.codigo || "") : "");
                                                            setItemValue(row.numero, "modelo", modelo ? (modelo.nombre || "") : "");
                                                            // Al cambiar de modelo se limpian el area y
                                                            // sus hijos: no aplican al modelo nuevo.
                                                            setItemValue(row.numero, "idArea", 0);
                                                            setItemValue(row.numero, "area", "");
                                                            setItemValue(row.numero, "idAreaObjetivo", 0);
                                                            setItemValue(row.numero, "objetivo", "");
                                                            setItemValue(row.numero, "idAreaObjetivoCriterio", 0);
                                                            setItemValue(row.numero, "criterio", "");
                                                            cargarAreasDelModelo(id, row.numero);
                                                        }}
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {modelos.map((modelo) => (
                                                            <option key={modelo.id} value={modelo.id}>
                                                                {modelo.codigo || modelo.nombre || ""}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Box>

                                        {!sinArea(row) && (<Box sx={{ flex: "1 1 120px", minWidth: 100 }}>
                                            <FormControl required fullWidth>
                                                    <AutocompleteRegistro
                                                        label="Area"
                                                        name="idArea"
                                                        disabled={isReadOnly}
                                                        texto={row.area}
                                                        idSeleccionado={row.idArea}
                                                        opciones={row.areaModelo || []}
                                                        getLabel={(opcion) => opcion.nombre}
                                                        onTexto={(t) => setItemValue(row.numero, "area", t)}
                                                        onSeleccionar={(area) => {
                                                            const id = (area != null && area.id > 0) ? area.id : 0;
                                                            setItemValue(row.numero, "idArea", id);
                                                            setItemValue(row.numero, "area", area != null ? (area.nombre || "") : "");
                                                            // Al cambiar de area se limpian los hijos: el objetivo y el
                                                            // criterio del area anterior ya no aplican.
                                                            setItemValue(row.numero, "idAreaObjetivo", 0);
                                                            setItemValue(row.numero, "objetivo", "");
                                                            setItemValue(row.numero, "idAreaObjetivoCriterio", 0);
                                                            setItemValue(row.numero, "criterio", "");
                                                            cargarObjetivosDelArea(id, row.numero);
                                                            cargarCriteriosDelObjetivo(0, row.numero);
                                                        }}
                                                        onBuscar={(texto) => buscarArea(row.idModelo, texto)}
                                                        onRegistrarNuevo={(texto) => registrarArea(row.idModelo, texto, row.numero)}
                                                        puedeRegistrar={row.idModelo > 0}
                                                        mensajeFaltaPadre="Seleccione primero el Modelo."
                                                        tipoRegistro="area"
                                                    />
                                                </FormControl>
                                            </Box>)}

                                            {pideObjetivo(row) && !sinArea(row) && (
                                                <Box sx={{ flex: "1 1 120px", minWidth: 100 }}>
                                                <FormControl required fullWidth>
                                                    <AutocompleteRegistro
                                                        label="Objetivo"
                                                        name="idAreaObjetivo"
                                                        disabled={isReadOnly}
                                                        texto={row.objetivo}
                                                        idSeleccionado={row.idAreaObjetivo}
                                                        opciones={row.areaObjetivo || []}
                                                        getLabel={(opcion) => opcion.nombre || opcion.descripcion}
                                                        onTexto={(t) => setItemValue(row.numero, "objetivo", t)}
                                                        onSeleccionar={(objetivo) => {
                                                            const id = (objetivo != null && objetivo.id > 0) ? objetivo.id : 0;
                                                            setItemValue(row.numero, "idAreaObjetivo", id);
                                                            setItemValue(row.numero, "objetivo", objetivo != null ? (objetivo.nombre || objetivo.descripcion || "") : "");
                                                            // Al cambiar de objetivo se limpia el criterio del objetivo
                                                            // anterior.
                                                            setItemValue(row.numero, "idAreaObjetivoCriterio", 0);
                                                            setItemValue(row.numero, "criterio", "");
                                                            cargarCriteriosDelObjetivo(id, row.numero);
                                                        }}
                                                        onBuscar={(texto) => buscarObjetivo(row.idArea, texto)}
                                                        onRegistrarNuevo={(texto) => registrarObjetivo(row.idArea, texto, row.numero)}
                                                        puedeRegistrar={row.idArea > 0}
                                                        mensajeFaltaPadre="Seleccione primero el Area."
                                                        tipoRegistro="objetivo"
                                                    />
                                                </FormControl>
                                                </Box>
                                            )}

                                            {pideCriterio(row) && !sinArea(row) && (
                                                <Box sx={{ flex: "1 1 120px", minWidth: 100 }}>
                                                <FormControl required fullWidth>
                                                    <AutocompleteRegistro
                                                        label="Criterio"
                                                        name="idAreaObjetivoCriterio"
                                                        disabled={isReadOnly}
                                                        texto={row.criterio}
                                                        idSeleccionado={row.idAreaObjetivoCriterio}
                                                        opciones={row.areaObjetivoCriterio || []}
                                                        getLabel={(opcion) => opcion.descripcion || opcion.nombre}
                                                        onTexto={(t) => setItemValue(row.numero, "criterio", t)}
                                                        onSeleccionar={(criterio) => {
                                                            const id = (criterio != null && criterio.id > 0) ? criterio.id : 0;
                                                            setItemValue(row.numero, "idAreaObjetivoCriterio", id);
                                                            setItemValue(row.numero, "criterio", criterio != null ? (criterio.descripcion || criterio.nombre || "") : "");
                                                        }}
                                                        onBuscar={(texto) => buscarCriterio(row.idAreaObjetivo, texto)}
                                                        onRegistrarNuevo={(texto) => registrarCriterio(row.idAreaObjetivo, texto, row.numero)}
                                                        puedeRegistrar={row.idAreaObjetivo > 0}
                                                        mensajeFaltaPadre="Seleccione primero el Objetivo."
                                                        tipoRegistro="criterio"
                                                    />
                                                </FormControl>
                                                </Box>
                                            )}

                                        {!sinArea(row) && (
                                        <Box sx={{ flex: "1.5 1 150px", minWidth: 140 }}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-puntuaciongrupo">Puntuacion</InputLabel>
                                                <Select
                                                    native
                                                    label="Puntuacion"
                                                    value={row.idPuntuacionGrupo}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idPuntuacionGrupo", event.target.value)
                                                        setItemValue(row.numero, "puntuacionGrupo", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idPuntuacionGrupo',
                                                        id: 'input-puntuaciongrupo',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {(row.gruposPuntuacion || []).map((grupo) => (
                                                        <option key={grupo.id} value={grupo.id}>{grupo.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        )}
                                        <Box sx={{ flex: "1.2 1 190px", minWidth: 180, display: "flex", alignItems: "center", gap: 1 }}>
                                             <TextField
                                                 label="Detalle del criterio"
                                                 fullWidth
                                                 size="small"
                                                 value={row.detalle || ""}
                                                 onChange={(event) => {
                                                     setItemValue(row.numero, "detalle", event.target.value)
                                                 }}
                                                 disabled={isReadOnly}
                                             />
                                            <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar criterio"}
                texto={"Esta seguro de borrar el criterio?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default SessionCriterion;